<template>
    <div class="repairs">
        <b-modal
            v-model="nopdf"
            title="Document not found"
            class="modal-alerts"
            :ok-only="true"
            ok-title="Close"
            size="xl"
        >
            <h1>The requested document is not available</h1>
        </b-modal>
        <b-modal
            v-model="showHistory"
            title="Repair history"
            class="modal-alerts"
            :ok-only="true"
            ok-title="Close"
            size="xl"
        >
            <table width="100%">
                <tr v-for="h in history" :key="h.stp1">
                    <td>{{ h.stp1a }}</td>
                    <td>&rarr;</td>
                    <td>{{ h.stp1b }}</td>
                    <td>{{ h.stp2 }}</td>
                </tr>
            </table>
        </b-modal>
        <b-modal no-close-on-backdrop title="Document Preview" class="modal-success" v-model="docDlg" ok-variant="success" :ok-only="true" @ok="docDlg = false" ok-title="Close" size="lg">
            <div v-if="pdfpages>1">
                <button @click="pdfpage = pdfpage - 1" :disabled="pdfpage == 1">&#9111;</button>
                {{ pdfpage }} / {{ pdfpages }}
                <button @click="pdfpage = pdfpage + 1" :disabled="pdfpage == pdfpages">&#9112;</button>
            </div>
            <pdf :src="pdfsrc" :page="pdfpage" style="display: inline-block; width: 100%" @num-pages="pdfpages = $event" @page-loaded="pdfpage = $event">
            </pdf>
        </b-modal>
        <b-card class="askforrepair" title="Ask for a repair" v-if="askforrepair">
                    <b-alert v-model="showRequiredFieldMissing" variant="danger" dismissible>
                        one or more fields are missing
                    </b-alert>                    
                    <div>
                        <b-form @submit="onSubmit" @reset="onReset" id="newticket">
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-1"
                                        label="Company"
                                        label-for="input-company"
                                        _description="Company name"
                                    >
                                        <b-form-input
                                            id="input-company"
                                            v-model="form.company"
                                            type="text"
                                            placeholder="Company name"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-2"
                                        label="Contact person"
                                        label-for="input-contpers"
                                        _description="Contact person"
                                    >
                                        <b-form-input
                                            id="input-contpers"
                                            v-model="form.contPers"
                                            type="text"
                                            placeholder="Contact Person"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-8"
                                        label="Contact Phone number"
                                        label-for="input-phone"
                                    >
                                        <b-form-input
                                            id="input-phone"
                                            v-model="form.phone"
                                            type="text"
                                            placeholder="Enter the phone number to contact for more information"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-3"
                                        label="Select your machine"
                                        label-for="input-machine"
                                        _description="Select your machine"
                                    >
                                        <b-form-select
                                            id="input-machine"
                                            v-model="form.machine"
                                            :options="machines"
                                            placeholder="Select your machine"
                                            required
                                        ></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                        id="input-group-5"
                                        label="Part code"
                                        label-for="input-partcode"
                                    >
                                        <b-form-input
                                            id="input-partcode"
                                            v-model="form.partcode"
                                            type="text"
                                            placeholder="Enter the part code"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-6"
                                        label="Part matr."
                                        label-for="input-partmatr"
                                    >
                                    <b-form-input
                                            id="input-partmatr"
                                            v-model="form.partmatr"
                                            type="text"
                                            placeholder="Enter the part matr"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-6"
                                        label="Quantity"
                                        label-for="input-quantity"
                                    >
                                    <b-form-input
                                            id="input-quantity"
                                            v-model="form.quantity"
                                            type="number"
                                            placeholder="Enter the quantity"
                                            required
                                        ></b-form-input>
                                    </b-form-group>

                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-7"
                                        label="Description"
                                        label-for="input-description"
                                        _description="Fault Description"
                                    >
                                        <b-form-textarea
                                            id="input-description"
                                            v-model="form.description"
                                            rows="7"
                                            placeholder="Description"
                                            required
                                        ></b-form-textarea>
                                    </b-form-group>

                                </b-col>
                            </b-row>
                            <div>
                                Click on “Submit” to send the request for a repair to our Service Dept.
                                <br>
                                If you do not receive a confirmation e-mail within a few minutes, it might be possibile that your firewall is blocking the sending of the ticket. In this case, we suggest you to call us!
                            </div>
                            <b-button type="button" @click.prevent="askforrepair=false" variant="danger">Cancel</b-button>
                            <b-button type="submit" variant="primary">Submit</b-button>
                        </b-form>
                    </div>
        </b-card>
        <b-button @click="askForRepair()" v-if="!askforrepair && !$store.getters.ro && isClient" class="marsilli" >Ask for a repair</b-button>
        <b-container fluid v-if="!askforrepair">
            <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="info"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                    >
                    Data Sent
            </b-alert>
            <b-row>
                <b-col>
                    <AgGridVue 
                        style="width: calc(100% - 20px);height: calc(100vh - 130px);" 
                        class="ag-theme-alpine" 
                        :rowData="repairs"
                        :pagination="true" 
                        :paginationPageSize="18" 
                        :columnDefs="columnDefs" 
                        :defaultColDef="defaultColDef" 
                        @first-data-rendered="onFirstDataRendered"
                        @grid-ready="onGridReady" >
                    </AgGridVue>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import pdf from "vue-pdf";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);

export default {
    name: "Repairs",
    components: {
        AgGridVue,
        pdf,
    },
    data() {
        // console.log("AMM???",this.isAmministrativo(),this.$store.getters.amministrativo)
        return {
            nopdf: false,
            history: "",
            showHistory: false,
            columns: [{ label: "Invoice", field: "invoice", }, { label: "Expiration", field: "expiration" }, { label: "Total", field: "total", }, { label: "Debt", field: "debt", }, { label: "days", field: "days", }],
            debtDetail: [],
            debtDlg: false,
            docDlg: false,
            pdfsrc: undefined,
            firstTime: true,
            pdfpage: 1,
            pdfpages: 1,
            filter: "",
            repairs: [],
            machines: [],
            askforrepair: false,
			dismissCountDown: 0,
			dismissSecs: 5,
			form: {
				company: null,
				contPers: null,
				phone: null,
				machine: null,
				partcode: null,
				partmatr: null,
				quantity: 0,
                description: null,
			},
            showRequiredFieldMissing: false,
            defaultColDef: {
                sortable: true,
                filter: true,
                filterParams: { buttons: ["reset", "apply"] },
                resizable: true,
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [
                {
                    headerName: "Repair Auth.",
                    field: "aut_al_reso",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Repair code",
                    field: "rip_codice",
                    cellStyle: { cursor: 'pointer' },
                    // onCellClicked: this.onClientCellClicked,
                    filter: "agNumberColumnFilter",
                },
                {
                    hide: this.isClient,
                    headerName: "Customer",
                    field: "cust_ragsoc",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Part Code",
                    field: "codice_pezzo",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Part Matr.",
                    field: "matricola_pezzo",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Status",
                    field: "stato",
                    filter: "agTextColumnFilter",
                    onCellClicked: this.onStatusCellClicked,
                    cellStyle: params => {
                        if (params.value == 'Request registered') {
                            return {color: 'black', backgroundColor: '#b5cfb0'};
                        } else if (params.value == 'Shipped') {
                            return {color: 'white', backgroundColor: '#9A240D', cursor: 'pointer'};
                        } else {
                            return {color: 'black', backgroundColor: '#fff58b', cursor: 'pointer'};
                        }
                    }
                },
                {
                    hide: true,
                    // \r\n10 -> 20 da Fausto Cristini in data 09/04/2024 16:47:46\r\n20 -> 25 da Fausto Cristini in data 10/04/2024 17:09:00\r\n25 -> 30 da Camilla Fontana in data 11/04/2024 09:12:16\r\n30 -> 40 da Camilla Fontana in data 17/04/2024 11:13:42\r\n40 -> 50 da Fausto Cristini in data 17/04/2024 11:17:39\r\n50 -> 60 da Fausto Cristini in data 17/04/2024 11:25:58\r\n60 -> 70 da Antonio Tosoni in data 17/04/2024 14:25:48
                    headerName: "Status history",
                    field: "psg_stato",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Service Offer",
                    // cellClass: "ag-left-aligned-cell",
                    // maxWidth: 450,
                    // type: "leftAligned",
                    // cellStyle: { cursor: 'pointer' },
                    onCellClicked: this.onClientCellClicked,
                    field: "offerta_service",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "Offer Date",
                    field: "offerta_data",
                    filter: "agDateColumnFilter",
                    valueFormatter: this.dateFormatter2,
                },
                {
                    headerName: "Order number",
                    field: "odv_cli",
                    filter: "agTextColumnFilter",
                },
                {
                    headerName: "AWB",
                    field: "awb",
                    filter: "agTextColumnFilter",
                },
            ],
        };
    },
    async mounted() {
        this.repairs = await API.getRepairs();
        console.log("REPAIRS", this.repairs)
        this.machines = (await API.getUnits(false,'servicecare')).map(u => u.code + " - " + u.name)
        this.machines.unshift({id:0, text:""})
    },
    computed: {
        isClient() {
            return !this.$store.getters.marsilli
        },
    },
    methods: {
        async askForRepair(){
			this.askforrepair = true
			for(let fld in this.form){
				this.form[fld] = null
			}
			this.form.company = await API.getClientName()
			this.form.contPers = this.$store.getters.name + " " + this.$store.getters.surname
        },
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown
		},
		showAlert() {
			this.dismissCountDown = this.dismissSecs
		},
        isAmministrativo() {
            return this.$store.getters.amministrativo
        },
        formatter(value) {
            const fmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', })
            return fmt.format(value)
        },
		async onSubmit(){
			const formData = new FormData()
			formData.append('data', JSON.stringify(this.form))
			await API.sendAskRepair(formData)
			this.askforrepair = false
			this.showAlert()
		},
		onReset(){
		},
        async onClientCellClicked(value) {
            console.log("VALUE",value.data.psg_stato)
            let pdf = await API.getRepPDF(value.data.rip_codice)
            console.log("PDF",pdf)
            if (pdf && pdf.size > 11) { // 11 = NOT FOUND
                this.openPDF(pdf)
            } else {
                this.nopdf = true
            }
        },
        async onStatusCellClicked(value) {
            let steps = {
                "10": "Request registered",
                "20": "Analysis started",
                "25": "Analysis done",
                "30": "Report and offert sent",
                "40": "Offer accepted",
                "50": "Ongoing",
                "60": "Ready for the shipment",
                "70": "Shipped",
            }
            // \r\n10 -> 20 da Fausto Cristini in data 09/04/2024 16:47:46\r\n20 -> 25 da Fausto Cristini in data 10/04/2024 17:09:00\r\n25 -> 30 da Camilla Fontana in data 11/04/2024 09:12:16\r\n30 -> 40 da Camilla Fontana in data 17/04/2024 11:13:42\r\n40 -> 50 da Fausto Cristini in data 17/04/2024 11:17:39\r\n50 -> 60 da Fausto Cristini in data 17/04/2024 11:25:58\r\n60 -> 70 da Antonio Tosoni in data 17/04/2024 14:25:48
            console.log("VALUE",value.data.psg_stato)
            let tmp = value.data.psg_stato.split("\r\n")
            let history = []
            for (let i = 0; i < tmp.length; i++) {
                let p1 = tmp[i].indexOf("da")
                let p2 = tmp[i].indexOf("data")
                if(p1>0 && p2>p1) {
                    let step = tmp[i].substring(0,p1-1).split("->")
                    let data = tmp[i].substring(p2+5)
                    let stp1 = ""
                    if(steps[step[0].trim()])
                        stp1 = steps[step[0].trim()] + " -> "
                    else
                        stp1 = "Unknown ->"
                    if(steps[step[1].trim()])
                        stp1 += steps[step[1].trim()]
                    else
                        stp1 += "Unknown"
                    let stp2 = data
                    let t = stp1.split("->")
                    history.push({stp1,stp2,stp1a:t[0].trim(),stp1b:t[1].trim()})
                }
            }
            this.history = history
            this.showHistory = history.length > 0
        },
        async openPDF(pdf) {
            // var loadingTask = pdf.createLoadingTask(
            // 	API.getDocCall(this.m.codice, zfile, doc.id_file)
            // ); //"Gefran_1600-1800_d.pdf");
            // loadingTask.promise.then((pdf) => {
            // 	this.pdfpages = pdf.numPages;
            // 	// se cambio in fretta il viewer si incatorcia
            // 	setTimeout(() => {
            // 		this.enabled = true;
            // 	}, 2000);
            // });
            console.log("PDF", pdf)
            const blob = new Blob([pdf]);
            const objectUrl = URL.createObjectURL(blob, { type: 'application/pdf' });
            this.pdfsrc = objectUrl
            this.docDlg = true
        },
        cellRenderer(value) {
            // console.log("DATA:",value)
            if (value.data.amount > 0)
                return `<b><span style="color: red;">&#11044;</span></b>`
            else
                return `<b><span style="color: green;">&#11044;</span></b>`
        },
        clientFormatter(value) {
            // console.log("DATA:",value)
            if (value.data.amount > 0)
                return `(*) ${value.value}`
            else
                return `${value.value}`
        },
        dateFormatter(value) {
            console.log("DATA!:",value)
            if (value.value.getTime() == 0)
                return " - "
            else
                return value.value.toLocaleDateString();
        },
        dateFormatter2(value) {
            return value.value && value.data.offerta_service>"" ? value.value.split("T")[0] : ""
        },
        statusFormatter(value) {
            if(value.value=='Request registered')
                return `<span style="color: green;">${value.value}</span>`
            else
                return value.value
        },
        onGridReady(params) {
            console.log("onGridReady", params);
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
        },
        // eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
            console.log("onFirstDataRendered", event);
            this.columnApi.autoSizeAllColumns();
        },
        // eslint-disable-next-line no-unused-vars
        StoreUpdated(event) {
            // console.log("StoreUpdated", event);
            setTimeout(() => {
                this.columnApi.autoSizeAllColumns();
            }, 500)
        },
    },
};
</script>
<style>
table.debtdlg {
    width: 100%;
}

table.debtdlg td {
    text-align: center;
    padding: 2px;
}

table.debtdlg td.d {
    text-align: right;
    padding: 2px;
}
div.repairs button.marsilli {
    margin: 6px;
}
button.marsilli {
    background-color: #6b1106;
    border-color: #6b1106;
}
table.debtdlg th {
    text-align: center;
    padding: 2px;
}

div.spareparts td,
div.spareparts th {
    text-align: left;
}

.ag-left-aligned-cell {
    text-align: left;
}
</style>
